import "owl.carousel";
import "jquery.marquee";
import * as Sentry from "@sentry/browser";
import { BrowserTracing } from "@sentry/tracing";

import { Navigation } from "./components/Navigation";
import { Tabs } from "./components/Tabs";
import { Carousel } from "./components/Carousel";
import { Accordion } from "./components/Accordion";
import { Scroll } from "./components/Scroll";
import { Close } from "./components/Close";
import { ScrollActive } from "./components/ScrollActive";
import { Anchor } from "./components/AnchorLink";
import { Select } from "./components/Select";
import { Filter } from "./components/Filter";
import { ShowMore } from "./components/ShowMore";
import { CheckEmpyInput } from "./components/CheckEmpyInput";

Navigation();
Tabs();
Carousel();
Close();
Anchor();
Accordion();
Select();
ScrollActive();
Scroll();
Filter();
ShowMore();
CheckEmpyInput();

import "./modules/auth";
import "./modules/helps";
import { init } from "./modules/init";
import { ticker } from "./modules/ticker";

init();

Sentry.init({
  dsn: "https://3cb3a4889b74e0ad13301c3fb2d84299@o415134.ingest.us.sentry.io/4511807447564288",

  integrations: [new BrowserTracing()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 0.0,
});

if (document.getElementById("marquee-list")) {
  ticker([
    'BTCUSDT', 'ETHUSDT', 'ETHBTC', 'LINKUSDT', 'LINKBTC', 'SXPUSDT', 'SXPBTC', 'EOSUSDT', 'EOSBTC', 'BCHUSDT', 'BCHBTC'
  ]);
}
